module.exports = __webpack_public_path__ + "img/kelpie-3.06a3012b.jpg";